import component from './PhLaunchBadge.vue'
export default component
